import axiosInstance from "../config/API";

const API_ENDPOINT = "/area.php";

// Fetch all areas
export const fetchAreasApi = async (searchText = "") => {
  const payload = {
    search_text: searchText,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("fetch areas:", response.data.body.Area);
  return response.data.body.Area || [];
};

// Add a new area
export const addAreaApi = async (areaData) => {
  const payload = {
    area_name: areaData.area_name,
    area_prefix: areaData.area_prefix,
    current_user_id: areaData.current_user_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("add area:", response.data);
  return response.data;
};

// Update an area
export const updateAreaApi = async (areaData) => {
  const payload = {
    area_name: areaData.area_name,
    area_prefix: areaData.area_prefix,
    current_user_id: areaData.current_user_id,
    edit_area_id: areaData.area_id,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("update area:", response.data);
  return response.data;
};

// Delete an area
export const deleteAreaApi = async (areaId, currentUserId) => {
  const payload = {
    delete_area_id: areaId,
    current_user_id: currentUserId,
  };
  const response = await axiosInstance.post(API_ENDPOINT, payload);
  console.log("delete area:", response.data);
  return response.data;
};
